import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  count: number;
  activeStepIndex: number;
};

export const ProgressLine = (props: Props) => {
  const { className, count, activeStepIndex } = props;
  return (
    <div className={cn("flex h-0.5 w-full flex-nowrap gap-x-2", className)}>
      {Array.from({ length: count }).map((_, index) => {
        const isFilled = index <= activeStepIndex;
        return (
          <div
            key={index}
            className={cn(
              "bg-dark-grey inline-flex h-full w-full rounded-full",
              isFilled && "bg-clear-blue"
            )}
          ></div>
        );
      })}
    </div>
  );
};
